import { SelectValueRenderer } from '../model';

export const SelectDefaultValueRenderer: SelectValueRenderer = ({ value }) => {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{value}</>;
};
